<script lang="ts">
    import { toasts, dismiss, type ToastVariant } from "../toast";

    const variantStyles: Record<ToastVariant, string> = {
        info: "border-[var(--border)] bg-[var(--popover)]",
        success:
            "border-[var(--success)]/40 bg-[color-mix(in_oklch,var(--success)_18%,var(--popover))]",
        error:
            "border-[var(--destructive)]/40 bg-[color-mix(in_oklch,var(--destructive)_18%,var(--popover))]",
        warning:
            "border-[var(--warning)]/40 bg-[color-mix(in_oklch,var(--warning)_18%,var(--popover))]",
    };
</script>

<div
    class="fixed bottom-4 right-4 z-[200] flex flex-col gap-2 w-[min(380px,calc(100vw-2rem))]"
>
    {#each $toasts as t (t.id)}
        <div
            role="status"
            class="rounded-lg border p-3 shadow-xl shadow-black/20 text-sm text-[var(--popover-foreground)] animate-in slide-in-from-right-4 fade-in-0 duration-200 {variantStyles[t.variant]}"
        >
            <div class="flex items-start gap-2">
                <div class="flex-1 min-w-0">
                    {#if t.title}
                        <div class="font-semibold leading-none">{t.title}</div>
                    {/if}
                    <div
                        class="{t.title
                            ? 'mt-1.5'
                            : ''} text-[var(--popover-foreground)]/90 break-words"
                    >
                        {t.message}
                    </div>
                </div>
                <button
                    type="button"
                    on:click={() => dismiss(t.id)}
                    aria-label="Закрыть"
                    class="size-5 inline-flex items-center justify-center rounded text-[var(--muted-foreground)] hover:text-[var(--foreground)] hover:bg-[var(--accent)] transition-colors cursor-pointer"
                >
                    <svg
                        width="11"
                        height="11"
                        viewBox="0 0 16 16"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                    >
                        <path d="M3 3l10 10M13 3L3 13" />
                    </svg>
                </button>
            </div>
        </div>
    {/each}
</div>
